module.exports = __webpack_public_path__ + "img/active-campaign.5ba4608b.svg";